import React from 'react';
import { DEFAULT_FILTERS_STATE } from '../../../../../config/constants';
import { firstLetterToUpperCase } from '../../../../../helpers/helpers';
import { Show } from '../../types';

export default React.memo(({ show, setOnShow } : { show: Show, setOnShow: (newShow: Show) => void }) => {

  const handleCheckboxFilter = (event : React.ChangeEvent<HTMLInputElement>) => {
    setOnShow({ ...show, [event.target.value]: !show[event.target.value] });
  };

  const FiltersInput = ({ keyName, keyIndex } : { keyName: string, keyIndex: number }) => (
    <div>
      <input
        type="checkbox"
        id={`styled-checkbox-${keyIndex}`}
        className="styled-checkbox"
        value={keyName}
        onChange={handleCheckboxFilter}
        checked={show[keyName]} />
      <label htmlFor={`styled-checkbox-${keyIndex}`} className="check-l" />
      <b>Show {firstLetterToUpperCase(keyName)}</b>
    </div>
  );

  return (
    <>
      {Object.keys(DEFAULT_FILTERS_STATE).map((keyName, ind) => (
        <FiltersInput key={keyName} keyName={keyName} keyIndex={ind} />
      ))}
      <div style={{ marginLeft: '50px' }}>
        <label style={{ borderRadius: '50%', height: '20px', width: '20px', background: '#167FB7', marginBottom: '-4px', marginRight: '5px' }}></label>
        OFFENSE
      </div>
      <div>
        <label style={{ borderRadius: '50%', height: '20px', width: '20px', background: '#DE3030', marginBottom: '-4px', marginRight: '5px' }}></label>
        DEFENSE
      </div>
    </>
  );
});
